export default __webpack_public_path__ + "static/media/attach.dc0ce9b9.svg";